import Input from './Input'
import Button from './Button'
import Select from './Select'
import Radio from './Radio'

const Controls = { Input, Button, Select, Radio }

export default Controls
